import { BRAND, gameUrl } from "./config";

export async function makeShareCard(houses: number, score: number): Promise<Blob> {
  const size = 1080;
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Could not draw the share card");

  const sky = ctx.createLinearGradient(0, 0, 0, size);
  sky.addColorStop(0, "#0b1220");
  sky.addColorStop(0.55, "#1a2034");
  sky.addColorStop(1, "#3a2a22");
  ctx.fillStyle = sky;
  ctx.fillRect(0, 0, size, size);

  ctx.fillStyle = "rgba(255,236,190,0.9)";
  ctx.beginPath();
  ctx.arc(860, 180, 54, 0, Math.PI * 2);
  ctx.fill();

  drawShareHouse(ctx, 90, 620, 210, true);
  drawShareHouse(ctx, 340, 590, 250, true);
  drawShareHouse(ctx, 640, 640, 200, houses > 0);
  drawShareHouse(ctx, 860, 610, 180, houses > 3);

  ctx.fillStyle = "rgba(8,10,16,0.55)";
  ctx.fillRect(70, 70, 940, 420);

  ctx.fillStyle = "#f3e6c4";
  ctx.font = "600 36px Georgia, 'Iowan Old Style', serif";
  ctx.fillText(BRAND.name, 110, 140);

  ctx.fillStyle = "#ffffff";
  ctx.font = "800 72px ui-sans-serif, system-ui, sans-serif";
  const line = houses === 1 ? "I lit 1 house." : `I lit ${houses} houses.`;
  ctx.fillText(line, 110, 240);

  ctx.fillStyle = "#ffd27a";
  ctx.font = "700 48px ui-sans-serif, system-ui, sans-serif";
  ctx.fillText("Beat that.", 110, 310);

  ctx.fillStyle = "#c8c0b0";
  ctx.font = "500 28px ui-sans-serif, system-ui, sans-serif";
  ctx.fillText(`Score ${score}  ·  ${BRAND.veteran}`, 110, 370);
  ctx.fillText(gameUrl().replace(/^https?:\/\//, ""), 110, 420);

  return await new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("Share card failed"));
    }, "image/png");
  });
}

export async function shareRun(houses: number, score: number): Promise<"shared" | "copied" | "downloaded"> {
  const blob = await makeShareCard(houses, score);
  const file = new File([blob], "sasquatch-roof-runner.png", { type: "image/png" });
  const url = gameUrl();
  const text = houses === 1
    ? `I lit 1 house in Roof Runner. Beat that. ${url}`
    : `I lit ${houses} houses in Roof Runner. Beat that. ${url}`;

  const nav = navigator as Navigator & {
    share?: (data: ShareData & { files?: File[] }) => Promise<void>;
    canShare?: (data: { files?: File[] }) => boolean;
  };

  if (nav.share && nav.canShare?.({ files: [file] })) {
    await nav.share({ files: [file], text, title: BRAND.gameName, url });
    return "shared";
  }
  if (nav.share) {
    await nav.share({ text, title: BRAND.gameName, url });
    return "shared";
  }

  try {
    await navigator.clipboard.writeText(text);
    downloadBlob(file);
    return "copied";
  } catch {
    downloadBlob(file);
    return "downloaded";
  }
}

function downloadBlob(file: File): void {
  const href = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = href;
  a.download = file.name;
  a.click();
  URL.revokeObjectURL(href);
}

function drawShareHouse(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, lit: boolean): void {
  ctx.fillStyle = "#2a1c18";
  ctx.beginPath();
  ctx.moveTo(x - 8, y);
  ctx.lineTo(x + w / 2, y - 90);
  ctx.lineTo(x + w + 8, y);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = "#4a3228";
  ctx.fillRect(x, y, w, 160);
  ctx.fillStyle = lit ? "#ffd27a" : "#1a1612";
  ctx.fillRect(x + 24, y + 28, 28, 28);
  ctx.fillRect(x + w - 52, y + 28, 28, 28);
  if (lit) {
    ctx.fillStyle = "#ffbf5e";
    for (let i = 0; i < 10; i++) {
      const t = i / 9;
      const px = x + t * w;
      const py = y - 8 - Math.sin(t * Math.PI) * 80;
      ctx.beginPath();
      ctx.arc(px, py, 4, 0, Math.PI * 2);
      ctx.fill();
    }
  }
}
